import { ReactNode } from 'react'

import { FormInstance } from 'antd'
import { NamePath } from 'antd/es/form/interface'

import { WrapperChildParams } from 'src/components/form/util'

/**
 * When a custom component inside Form.Item accepts value and onChange, the rendering behavior changes significantly.
 * Specifically, it appears the only way to guarantee that a non-antd component rerenders on validation change is to do this.
 * Antd will inject the onChange and value props.
 * Another important feature is that it is reading a fresh errorMessage each time it rerenders; DON'T pass the error from Wrapper.
 *
 * If you have questions about this ask ChatGPT (there is almost no documentation from antd) but sometimes ChatGPT gets confused with react-hook-form so ask it not to do that.
 */

type Props = {
  fieldName: NamePath
  form: FormInstance
  // onChange and value are magically injected by antd Form.Item, really not a good pattern for TypeScript
  onChange?: any
  tooltip?: string | null
  // onChange and value are magically injected by antd Form.Item, really not a good pattern for TypeScript
  value?: any
  render: (params: WrapperChildParams) => ReactNode
}
const GovWellUIWrapper = ({ render, fieldName, form, onChange, tooltip, value }: Props) => {
  const errorMessage = form.getFieldError(fieldName)?.[0]
  return render({
    errorMessage,
    tooltip,
    value,
    onValueChange: onChange,
  })
}
export default GovWellUIWrapper
